const REDUCE_COUPON = 0
const FULL_REDUCE = 0
// const FULL_GIFT_COUNT = 1
const FULL_GIFT_PRICE = 2
const ACTIVITY_REDUCE = 3
const CRM_REDUCE = 4
const INCREASE_COUPON = 'INCREASE_COUPON'

const ACTIVITY_EXCLUDE_PROD = ['HR1001', 'HR1002', 'IC0015', 'IC0017', 'IC0034', 'IC0053', 'TP0001', "IC0041", "IC0046", "IC0064", "QF0001", "QF0002", "QF0003", "QF0004", "QF0005", "QF0006", "QF0007", "QF0008", "QF0012"]

class Coupon {
  type = 0
  fullPrice = 0
  offPrice = 0
  giftPrice = 0
}

class CouponCode {
  /**
   * 优惠券信息
   * @type Coupon
   */
  coupon = new Coupon()
  cartId = -1

  isSelected = false

  /**
   *
   * @param code CouponCode
   */
  compare(code) {
    let score = this.coupon.offPrice || this.coupon.giftPrice
    let score1 = code.coupon.offPrice || code.coupon.giftPrice
    return score > score1 ? 1 : (score === score1 ? 0 : -1)
  }

  matchCart(cart) {
    let coupon = this.coupon
    return cart.serialId.indexOf(coupon.serialId) > 0 || coupon.serialId === ''
  }

  // 检查当前优惠券对应的购物车产品是否符合活动要求
  matchActivityCart(cart) {
    let coupon = this.coupon
    if(coupon.type === ACTIVITY_REDUCE) {
      let serialId = cart.serialId ? cart.serialId.substr(4, 6) : ''
      return ACTIVITY_EXCLUDE_PROD.indexOf(serialId) === -1
    } else {
      return true
    }
  }
  /**
   *
   * @param cart Checkout
   * @returns {boolean}
   */
  matchFullPrice(cart) {
    if (!this.matchCart(cart)) {
      return false
    }
    let _coupon = this.coupon

    if (_coupon.fullPrice === 0) {
      console.log(`matchFullPrice,fullPrice=0`)
      return true
    }
    else {
      let originTotalPrice = cart.originTotalPrice
      console.log(`matchFullPrice,fullPrice=${_coupon.fullPrice},cartPrice=${originTotalPrice}`)
      return _coupon.fullPrice <= originTotalPrice
    }
  }

  get isOffPrice() {
    return this.coupon.type === FULL_REDUCE
  }

  get isActivityOffPrice() {
    return this.coupon.type === ACTIVITY_REDUCE
  }

  get isGiftPrice() {
    return this.coupon.type === FULL_GIFT_PRICE
  }

  get isCrmReduce() {
    return this.coupon.type === CRM_REDUCE
  }

  /**
   * 优惠券的抵扣金额
   * @returns {boolean|*|number}
   */
  get offPrice() {
    return this.coupon.offPrice || 0
  }

  /**
   * 优惠券 赠送的月份
   * todo refactor
   * @param code
   * @returns {boolean|*|number}
   */
  extraAmount(code) {
    let coupon = code && code.coupon || false
    let _extraAmount
    if (coupon) {
      if (coupon.type === INCREASE_COUPON) {
        _extraAmount = coupon.incAmount
      }
    }
    return (_extraAmount >= 0) && _extraAmount || 0
  }

}

export default CouponCode

/**
 *   UN_GET: '',
 UN_USE: '未使用',
 FROZEN: '冻结中',
 USED: '已使用',
 * @type {[*]}
 */
export const
  STATES = [
    '未领用',
    '未使用',
    '冻结中',
    '已使用',
  ]



// WEBPACK FOOTER //
// ./src/domain/coupon.js